import axios from 'axios';
import { getAccessToken } from '@/lib/supabase';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = 'curbalert_token';
export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch (e) { console.debug('token read failed:', e?.message || e); return null; }
};
export const setToken = (token) => {
  try { token ? localStorage.setItem(TOKEN_KEY, token) : localStorage.removeItem(TOKEN_KEY); } catch (e) { console.debug('token write failed:', e?.message || e); }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach the current Supabase access token (auto-refreshed) as a bearer so auth
// works even when 3rd-party cookies are blocked. Falls back to a legacy token.
api.interceptors.request.use(async (config) => {
  const supaToken = await getAccessToken();
  const token = supaToken || getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const fileUrl = (path) =>
  path === 'default_yard_sale'
    ? 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=900&auto=format&fit=crop'
    : `${API}/files/${path}`;
